import axios from 'axios'

export default {
    getFeedbackData() {
        return axios.get('ru/api/public/feedback/formData')
    },
    createFeedback(data) {
        return axios.post('ru/api/public/feedback/create', data)
    }
}